import { defineComponent as _defineComponent } from 'vue'
import 'select2';

import $ from 'jquery';
import {
    onBeforeUnmount, onMounted, shallowRef, unref, watch,
} from 'vue';

import { bindCustomSelect } from '#public/commons-global';
import { type ComponentState, useGenerateIds, useJqueryEventListener } from '#public_ts/composables';

import updateDataAttributes from './data-attributes';

type SelectType = 'default' | 'custom' | string[] | Record<string, string> | Map<string, string>;

export default /*#__PURE__*/_defineComponent({
  __name: 'bootstrap-select2',
  props: {
    id: null,
    name: null,
    value: null,
    options: null,
    type: null,
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    state: null,
    data: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: string | string[] | undefined): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    id?: string;
    name?: string;
    value?: string | string[];
    options?: Partial<Select2Options>;
    type?: SelectType;
    disabled?: boolean;
    readonly?: boolean;
    state?: ComponentState;
    data?: Record<string, unknown>;
}


//eslint-disable-next-line no-spaced-func

const selectElement = shallowRef<HTMLElement | undefined>();
let selectedValue = unref(props.value);
const generateIds = useGenerateIds();
const controlId = props.id || generateIds();
const controlName = props.name || controlId;

function checkUpdateState() {
    const _selectElement = unref(selectElement);
    if(_selectElement) {
        $(_selectElement).select2('enable', !props.disabled).select2('readonly', !!props.readonly);
    }
}
function checkUpdateValue() {
    const _selectElement = unref(selectElement);
    if(_selectElement) {
        const val = $(_selectElement).select2('val') as string | string[] | undefined;
        if(val !== selectedValue) {
            selectedValue = val;
            emit('input', selectedValue);
        }
    }
}
function init() {
    const _selectElement = unref(selectElement);
    if(_selectElement) {
        if(!props.type || (props.type === 'default') || (props.type === 'custom')) {
            $(_selectElement).select2(props.options || {
                dropdownAutoWidth: true,
            });
        } else {
            bindCustomSelect($(_selectElement), props.type, props.options);
        }
        checkUpdateState();
        if(selectedValue) {
            $(_selectElement).select2('val', selectedValue);
        } else {
            checkUpdateValue();
        }
        if(props.data) {
            updateDataAttributes($(_selectElement), props.data);
        }
    }
}

function reinit() {
    const _selectElement = unref(selectElement);
    if(_selectElement) {
        $(_selectElement).select2('destroy');
        init();
    }
}

const onUpdate = props.state?.onUpdate(reinit);

onMounted(init);
onBeforeUnmount(() => {
    const _selectElement = unref(selectElement);
    if(_selectElement) {
        $(_selectElement).select2('destroy');
    }
    onUpdate?.off();
});

watch([() => props.options, () => props.type], () => {
    reinit();
});

useJqueryEventListener(selectElement, 'change', checkUpdateValue);
watch(() => props.value, (val) => {
    const _selectElement = unref(selectElement);
    if(_selectElement && (val !== selectedValue)) {
        selectedValue = val;
        $(_selectElement).select2('val', selectedValue);
        checkUpdateValue();
    }
});

watch([() => props.disabled, () => props.readonly], checkUpdateState);

watch(() => props.data, (val) => {
    const _selectElement = unref(selectElement);
    if(_selectElement && val) {
        updateDataAttributes($(_selectElement), val);
    }
}, { deep: true });

return { __sfc: true,props, emit, selectElement, selectedValue, generateIds, controlId, controlName, checkUpdateState, checkUpdateValue, init, reinit, onUpdate }
}

})